import React from 'react';

type ImportSynchTripWizard = {
  fileContent;
  setFileContent;
  setNextButtonDisallowed;
  synchTripImportDTOList;
  setSynchTripImportDTOList;
};

const ImportSynchTripWizardContext = React.createContext<ImportSynchTripWizard>({
  fileContent: null,
  setFileContent: (val) => {},
  setNextButtonDisallowed: (val) => {},
  synchTripImportDTOList: null,
  setSynchTripImportDTOList: (val) => {},
});

export default ImportSynchTripWizardContext;
